import { Box, Checkbox, SxProps, Theme } from '@mui/material'
import { useInput, Validator } from 'react-admin'

export type Props = {
  source: string
  children?: React.ReactNode
  defaultValue?: boolean
  validate?: Validator | Validator[]
  onChange?: (e: unknown[]) => void
  onBlur?: (e: unknown[]) => void
  sx?: SxProps<Theme>
}

const CheckboxInput = ({
  source,
  children,
  defaultValue = false,
  validate,
  onChange,
  onBlur,
  sx
}: Props) => {
  const {
    id,
    field: { value, ...fieldRest },
    isRequired
  } = useInput({
    type: 'checkbox',
    source,
    validate,
    defaultValue,
    onChange,
    onBlur
  })

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        ...sx
      }}
    >
      <Checkbox
        id={id}
        defaultChecked={defaultValue}
        required={isRequired}
        {...fieldRest}
      />
      {children}
    </Box>
  )
}

export default CheckboxInput
